import { gql } from '@apollo/client'

export const GET_WALLET_TRANSACTIONS = gql`
    query GetWalletTransactions($userEmail: EmailAddress!, $page: PageInput!) {
        getWalletTransactions(user_email: $userEmail, page: $page) {
            code
            success
            message
            tranx_count
            wallet {
                user_email
                balance
                hold_balance
                last_updated
            }
            tranx {
                tranx_id
                tranx_date
                tranx_type
                amount
                status
                description
            }
        }
    }
`
